export default __webpack_public_path__ + "static/ai-page-59840436744020eba9199c73bc79ad28.jpg";